<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
	value: boolean
	label: string
}>()

const emit = defineEmits<{
	(event: 'input', value: boolean): void
}>()

const model = computed({
	get() {
		return props.value
	},
	set(value: boolean) {
		emit('input', value)
	},
})
</script>

<template>
	<div class="map-info-toggle">
		<div class="map-info-toggle__switch">
			<input
				id="map-info-toggle"
				v-model="model"
				type="checkbox"
			/>
		</div>
		<label
			class="map-info-toggle__label text-s-bold"
			for="map-info-toggle"
		>
			{{ label }}
		</label>
	</div>
</template>

<style scoped>
.map-info-toggle {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 4px 8px;
	height: 32px;
	background: #fefefe;
	border: 1px solid #737576;
	border-radius: 4px;
	user-select: none;
	cursor: pointer;
}

.map-info-toggle__switch {
	display: flex;
	position: relative;
	flex-shrink: 0;
}

.map-info-toggle__switch input[type='checkbox'] {
	cursor: pointer;
	width: 48px;
	height: 24px;
	background-color: #b9baba;
	appearance: none;
	outline: none;
	border-radius: 22px;
	transition: background-color 0.1s linear;
	margin: 0;
}

.map-info-toggle__switch input[type='checkbox']:checked {
	background-color: #34617e;
}

.map-info-toggle__switch input[type='checkbox']::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	width: 24px;
	height: 24px;
	border-radius: 50%;
	background-color: #fefefe;
	border: 1px solid #34617e;
	box-shadow: 2px 2px 4px rgba(30, 30, 30, 0.25);
	transition: left 0.1s linear;
}

.map-info-toggle__switch input[type='checkbox']:checked::before {
	left: 24px;
}

.map-info-toggle__label {
	color: #464947;
	white-space: nowrap;
	cursor: pointer;
}
</style>
